// extracted by mini-css-extract-plugin
export var container = "KeyFeatures-module--container--a3495";
export var features = "KeyFeatures-module--features--e2b6b";
export var image = "KeyFeatures-module--image--20575";